import { SuperModel } from './super-model';

export class CheckBoxModel extends SuperModel {
    options = [];
    isReadonly: boolean;
    isHidden: boolean;
    fieldType: FieldType;
    fieldColumn: string;
    isRequired: boolean;
    additionalMetaData: MetadataBuilder = {};
    constructor(field) {
        super(field);
        this.additionalMetaData = field.additionalMetaData;
        if ([null, undefined].includes(this.additionalMetaData)) {
            this.additionalMetaData = {};
        }
        if (!this.additionalMetaData.hasOwnProperty('min')) {
            this.additionalMetaData.min = null;
        }
        if (!this.additionalMetaData.hasOwnProperty('max')) {
            this.additionalMetaData.max = null;
        }
        if (!field.additionalMetaData.hasOwnProperty('showLabel')) {
            this.additionalMetaData.showLabel = true;
        }
        if (!this.additionalMetaData.hasOwnProperty('changeEventEmit')) {
            this.additionalMetaData.changeEventEmit = true;
        }
        this.options = (field.hasOwnProperty('options')
            && !([null, undefined, ''].includes(field.options))) ? field.options : [];
    }
}

type FieldType = 'checkBox';

interface MetadataBuilder {
    min?: number;
    max?: number;
    labelPosition?: string;
    showLabel?: boolean;
    changeEventEmit?: boolean;
}
